<template>
  <div>
    <vuex-breadcrumb></vuex-breadcrumb>
    <user-update :id="id" @gotAttrs="assignAttrs"/>
    <profile-index
      :filtering="filtering"
      :ams_template="ams_template"
    ></profile-index>
  </div>
</template>

<script>
import VuexBreadcrumb from './VuexBreadcrumb.vue'
import UserUpdate from './UserUpdate.vue'
import ProfileIndex from './ProfileIndex.vue'

export default {
  components: {
    VuexBreadcrumb,
    UserUpdate,
    ProfileIndex
  },
  props: {
    id: String
  },
  data () {
    return {
      filtering: {
        user_ids: this.id
      },
      ams_template: {
        type: 'profiles',
        description: undefined,
        attributes: {
          'user-id': this.id,
        }
      },
      attrs: {},
    }
  },
  methods: {
    assignAttrs(attrs, description) {
      this.attrs = Object.assign( {}, attrs)
      this.ams_template.description = description + ' ' + this.attrs['name'] + ' ' + this.attrs['email']
    }
  }
}
</script>